export interface RoleIconType {
  icon: string;
}

export const roleIcons = [
  { icon: 'fa fa-university' },
  { icon: 'fas fa-graduation-cap' },
  { icon: 'fas fa-user-graduate' },
  { icon: 'fas fa-book' },
  { icon: 'fas fa-users' },
  { icon: 'fa fa-user-tie' },
  { icon: 'fa fa-suitcase' },
  { icon: 'fa fa-handshake' },
  { icon: 'fa fa-globe-europe' }
];
